import {
  hotspotIcon,
  generateCustomIconXml
} from '~js/helpers'

const getMarkerMultitagXml = function (marker, ath, atv, category, useCustomIcon, index, markerScale) {
  let tag = ''
  const opacity = marker.opacity ? (marker.opacity / 100) : 0.6
  if (marker.customCoordinate && marker.coordinatePlane !== 0 && marker.rotation) {
    const inverserotation = (marker.coordinatePlane === 3)
    const rx = marker.coordinatePlane === 3 ? 90 - atv + (-90 - marker.rotation.x) : atv
    const ry = marker.coordinatePlane === 3 ? 0 : -ath + 90 - marker.rotation.y
    const rz = marker.rotation.z
    tag += `<hotspot
      name="marker_${marker.objectId}"
      style="${hotspotIcon(marker, useCustomIcon)}"
      scale="${markerScale}"
      ath="${ath}"
      atv="${atv}"
      alpha="${opacity}"
      zorder="${marker.index}"
      distorted="true"
      inverserotation="${inverserotation}"
      rx="${rx}"
      ry="${ry}"
      rz="${rz}"
      mipmapping="true"
      enabled="${!marker.disabled}"
      capture="false"
      ${generateCustomIconXml(marker)}
      onclick="set_marker_info(${index});"
      onover="marker_mousein(${marker.objectId}, ${index});"
      onout="marker_mouseout(${marker.objectId}, ${index}, null, ${opacity});" />`
  } else {
    tag += `<hotspot
      name="marker_${marker.objectId}"
      style="${hotspotIcon(marker, useCustomIcon)}"
      scale="${markerScale}"
      ath="${ath}"
      atv="${atv}"
      alpha="${opacity}"
      zorder="${marker.index}"
      enabled="${!marker.disabled}"
      capture="false"
      ${generateCustomIconXml(marker)}
      onclick="set_marker_info(${index});"
      onover="marker_mousein(${marker.objectId}, ${index});"
      onout="marker_mouseout(${marker.objectId}, ${index}, null, ${opacity});" />`
  }
  return tag
}

export default getMarkerMultitagXml
